function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import React, { createContext, useState } from "react";
import PropTypes from "prop-types";
import { Provider as ToastProvider, Viewport } from "@radix-ui/react-toast";
import { thunkOptions } from "../../../providers/reduxProvider";
export var FlashMessengerContext = /*#__PURE__*/ createContext(null);
FlashMessengerProvider.propTypes = {
    children: PropTypes.node.isRequired
};
var FLASH_MSG_DURATION = 5000; //!The actual duration it will close is 10000, from FlashMessenger.jsx...
export default function FlashMessengerProvider(param) {
    var children = param.children;
    var _useState = _sliced_to_array(useState(null), 2), message = _useState[0], setMessage = _useState[1];
    var _useState1 = _sliced_to_array(useState(false), 2), opened = _useState1[0], setOpened = _useState1[1];
    function setSuccessMessage(param) {
        var message = param.message, _param_duration = param.duration, duration = _param_duration === void 0 ? FLASH_MSG_DURATION : _param_duration;
        //? Close the current message to reset the timer
        setOpened(false);
        setTimeout(function() {
            setMessage({
                message: message,
                type: "success",
                duration: duration
            });
            setOpened(true); //? Trigger the message to open again with refreshed duration
        }, 50); //! Small timeout to ensure the state is updated correctly, used 50 since 0 is bugged on ios
    }
    function setErrorMessage(param) {
        var message = param.message, _param_duration = param.duration, duration = _param_duration === void 0 ? FLASH_MSG_DURATION : _param_duration;
        //? Close the current message to reset the timer
        setOpened(false);
        setTimeout(function() {
            setMessage({
                message: message,
                type: "error",
                duration: duration
            });
            setOpened(true); //? Trigger the message to open again with refreshed duration
        }, 50); //! Small timeout to ensure the state is updated correctly, used 50 since 0 is bugged on ios
    }
    function removeMessage() {
        setMessage(null);
    }
    var returnedValue = {
        setSuccessMessage: setSuccessMessage,
        setErrorMessage: setErrorMessage,
        removeMessage: removeMessage,
        message: message,
        opened: opened,
        setOpened: setOpened
    };
    // We do this so we can use flash messages methods outside react components too
    if (!thunkOptions.flashMessenger) {
        thunkOptions.flashMessenger = returnedValue;
    }
    return /*#__PURE__*/ React.createElement(ToastProvider, null, /*#__PURE__*/ React.createElement(FlashMessengerContext.Provider, {
        value: returnedValue
    }, children, /*#__PURE__*/ React.createElement(Viewport, {
        className: "fixed right-0 top-0 z-[100] w-full p-3 sm:w-[500px]"
    })));
}
